/*
 *  I04CONCLIMCONSCalcul.js
 *
 *  Created by Sébastien Hecart on 2018-04-01 12:38:50 +0000.
 *  Copyright © 2017 Sebastien Hecart. All rights reserved.
 *
 *
 */
import { I04CONCLIMCONS_State } from '@batical/types/src'

function I04CONCLIMCONS_docalcul(state: I04CONCLIMCONS_State, isWeb = false) {
  //ameliorer en calculant que les nouveaux et pas tout mais OSEF
  if (!isWeb) {
    let line = []
    for (let index = 0; index < state.in_nombreAnnee; index++) {
      if (state.in_djus[index] !== 0) {
        state.res_conso[index] = (state.in_conso[index] * state.in_djureference) / state.in_djus[index]
      } else {
        state.res_conso[index] = 0
      }
      line.push({
        x: state.in_annee[index].toString(),
        conso: state.in_conso[index],
        consoConstant: state.res_conso[index]
      })
    }

    state.line = line.sort((a, b) => {
      return Number(a.x) - Number(b.x)
    })
    state.res_minConso = Math.min(
      state.res_conso.reduce((a, b) => Math.min(a, b)),
      state.in_conso.reduce((a, b) => Math.min(a, b))
    )
    state.res_maxConso = Math.max(
      state.res_conso.reduce((a, b) => Math.max(a, b)),
      state.in_conso.reduce((a, b) => Math.max(a, b))
    )
  } else {
    let conso = []
    let consoConstant = []

    for (let index = 0; index < state.in_nombreAnnee; index++) {
      if (state.in_djus[index] !== 0) {
        state.res_conso[index] = (state.in_conso[index] * state.in_djureference) / state.in_djus[index]
      } else {
        state.res_conso[index] = 0
      }
      conso.push({ x: state.in_annee[index], y: Math.round(state.in_conso[index]) })
      consoConstant.push({ x: state.in_annee[index], y: Math.round(state.res_conso[index]) })
    }
    state.line_conso_web = []
    state.line_conso_web.push({ id: 'Consommation', color: 'hsl(70, 70%, 50%)', data: conso })
    state.line_conso_web.push({ id: 'Consommation Constante', color: 'hsl(344, 70%, 50%)', data: consoConstant })
    state.res_minConso = Math.min(
      state.res_conso.reduce((a, b) => Math.min(a, b)),
      state.in_conso.reduce((a, b) => Math.min(a, b))
    )
    state.res_maxConso = Math.max(
      state.res_conso.reduce((a, b) => Math.max(a, b)),
      state.in_conso.reduce((a, b) => Math.max(a, b))
    )
    return state
  }
  state.invalidated = false
  return state
}

export default I04CONCLIMCONS_docalcul
